<template>
  <div class="card" :class="`${withShadow ? 'card--shadow' : '' }`">
<!-- <el-row :gutter="10">
<el-col :xs="8" :sm="6" :md="4" :lg="3" :xl="1"><div class="grid-content bg-purple"></div></el-col>
<el-col :xs="4" :sm="6" :md="8" :lg="9" :xl="11"><div class="grid-content bg-purple-light"></div>
</el-col>
<el-col :xs="4" :sm="6" :md="8" :lg="9" :xl="11"><div class="grid-content bg-purple"></div></el-col>
<el-col :xs="8" :sm="6" :md="4" :lg="3" :xl="1"><div class="grid-content bg-purple-light"></div>
</el-col>
</el-row> -->
    <slot/>
  </div>
</template>

<script>
export default {
  props: {
    withShadow: { type: Boolean, required: false, default: false },
  },
};
</script>

<style lang="stylus" scoped>
.card {
  /* border: 1px solid #d7dded;
  border-radius: 6px;
  padding: 16px 32px 24px;
  background: #fff;
  */
  padding: 16px 20px 24px;
}

.card--shadow {
  box-shadow: 0px 1px 3px rgba(0,0,0, 0.1);
}

</style>
